import { render, staticRenderFns } from "./ChooseKit.vue?vue&type=template&id=485d5435"
import script from "./ChooseKit.vue?vue&type=script&lang=js"
export * from "./ChooseKit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports